import { createApp } from "vue";
import App from "./App.vue";
import router from "@/router/router";
import vuetify from "@/plugins/vuetify";
import { loadFonts } from "@/plugins/webfontloader";
import i18n from "@/plugins/i18n";
import { createPinia } from "pinia";
import "@/registerServiceWorker";

loadFonts();

createApp(App)
    .use(createPinia())
    .use(router)
    .use(i18n)
    .use(vuetify)
    .mount("#app");
